    <div class="header-area fixed-top text-light"
    style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <div class="main-header header-sticky">
    <div class="container">
    <div class="row align-items-center">
    
    <div class="col-xl-2 col-lg-2 col-md-2">
    <div class="logo">
    <a routerLink="/"><img width="60" src="assets/img/logo.png" alt="cms sekolah"/></a>
    </div>
    </div>
    <div class="col-xl-10 col-lg-10 col-md-10">
    
    <div class="main-menu f-right d-none d-lg-block">
    <nav class="navbar">
    <ul id="navigation">
    <li class="active"><a href="/cms#"> Home</a></li>
     <li><a href="cms#about">About</a></li>
     <li><a href="cms#feature">Feature</a></li>
    <li><a href="cms#skema">Skema</a></li>
    <li><a href="cms#pricing">Pricing</a></li>
    </ul>
    </nav>
    </div>
    </div>
    
     </div>
    </div>
    </div>
    </div>
    
    
<div class="slider-area"
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
  background-attachment: fixed;
background-position: center; 
background-size: cover;
"
>
    <div class="slider-active">
    <div class="single-slider slider-height slider-padding sky-blue d-flex align-items-center">
    <div class="container bg-light shadow rounded">
    <div class="row d-flex align-items-center">
    <div class="col-12 col-lg-6 col-md-9 p-3 p-md-5">
    <div class="hero__caption">
        <img class="img-fluid" src="assets/img/logo.png" alt="cms sekolah"/>
    <span data-animation="fadeInUp" data-delay=".4s"><a class="text-secondary" href="https://axcoraschool.vercel.app">CMS SEKOLAH</a></span>
    <h1 data-animation="fadeInUp" data-delay=".6s" class="text-dark">Aplikasi website sekolah</h1>
    <p class="text-secondary" data-animation="fadeInUp" data-delay=".8s">Buat website dengan mudah via axcora school cms.</p>
    
    <div class="slider-btns">
    
    <a data-animation="fadeInLeft" data-delay="1.0s" href="/cms#pricing" class="btn radius-btn">Get Start Now</a>
  
    </div>
    </div>
    </div>
    <div class="col-12 col-lg-6">
    <div class="hero__img d-none d-lg-block f-right" data-animation="fadeInRight" data-delay="1s">
    <img class="img-fluid rounded" src="assets/img/aplikasi pembuatan website sekolah gratis dari axcora technology axcora school web app login.jpg" alt="cms sekolah"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div id="about" class="best-features-area section-padd4">
    <div class="container">
    <div class="row justify-content-end">
     <div class="col-xl-8 col-lg-10">
    
    <div class="row">
    <div class="col-lg-10 col-md-10">
    <div class="section-tittle">
    <h2 class="text-light"><a href="https://axcoraschool.vercel.app">CMS Sekolah</a> modern siap pakai</h2>
    </div>
    </div>
    </div>
    
    <div class="row">
    <div class="col-6 col-xl-6 col-lg-6 col-md-6">
    <div class="single-features mb-70">
    <div class="features-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="text-white bi bi-code-slash" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0zm-.999-3.124a.5.5 0 0 1 .33.625l-4 13a.5.5 0 0 1-.955-.294l4-13a.5.5 0 0 1 .625-.33z"/>
          </svg>
    </div>
    <div class="features-caption">
    <h3 class="text-light">Aplikasi Website Sekolah</h3>
    <p class="text-light">Special dipergunakan untuk project pembuatan website sekolah.</p>
    </div>
    </div>
    </div>
    <div class="col-6 col-xl-6 col-lg-6 col-md-6">
    <div class="single-features mb-70">
    <div class="features-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="text-white bi bi-heart" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
          </svg>
    </div>
    <div class="features-caption">
    <h3 class="text-light">Struktur Terbaik</h3>
    <p class="text-light">Dengan skema dan tema terbaik untuk kebutuhan sekolah siap pakai.</p>
    </div>
    </div>
    </div>
    <div class="col-6 col-xl-6 col-lg-6 col-md-6">
    <div class="single-features mb-70">
    <div class="features-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="text-white bi bi-controller" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.119 2.693c.904.19 1.75.495 2.235.98.407.408.779 1.05 1.094 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.815-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773a11.307 11.307 0 0 1-.739-.809c-.126-.147-.25-.291-.368-.422-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.422-.243.283-.494.576-.739.81-.398.378-.877.705-1.513.772a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772.486-.485 1.331-.79 2.235-.98.932-.196 2.03-.292 3.119-.292 1.089 0 2.187.096 3.119.292zm-6.032.979c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.505C4.861 9.97 5.978 9.026 8 9.026s3.139.943 3.965 1.855c.164.182.307.35.44.505.214.25.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z"/>
            <path d="M11.5 6.026a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-7-2.5h1v3h-1v-3z"/>
            <path d="M3.5 6.526h3v1h-3v-1zM3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .258.966l-1.932.518a.5.5 0 0 1-.612-.354zm9.976 0a.5.5 0 0 0-.353-.613l-1.932-.518a.5.5 0 1 0-.259.966l1.932.518a.5.5 0 0 0 .612-.354z"/>
          </svg>
    </div>
    <div class="features-caption">
    <h3 class="text-light">Backend Admin</h3>
    <p class="text-light">Fitur login backend admin dengan UI modern dan kemudahan dalam penggunaan nya.</p>
    </div>
    </div>
    </div>
    <div class="col-6 col-xl-6 col-lg-6 col-md-6">
    <div class="single-features mb-70">
     <div class="features-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="text-white bi bi-display" viewBox="0 0 16 16">
            <path d="M5.75 13.5c.167-.333.25-.833.25-1.5h4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75z"/>
            <path fill-rule="evenodd" d="M13.991 3H2c-.325 0-.502.078-.602.145a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3zM14 2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h12c2 0 2-2 2-2V4c0-2-2-2-2-2z"/>
          </svg>
    </div>
    <div class="features-caption">
    <h3 class="text-light">Frontend Website</h3>
    <p class="text-light">Penerapan desain modern dengan landing page semakin mewah untuk sekolah anda.</p>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    <div class="features-shpae d-none d-lg-block">
    <img class="img-fluid" src="assets/img/aplikasisekolah online web app (1).png" alt="cms website sekolah"/>
    </div>
    </div>
    
    
    <div id="feature" class="service-area sky-blue section-padding2">
    <div class="container">
    
    <div class="row d-flex justify-content-center">
    <div class="col-lg-6">
    <div class="section-tittle text-center">
    <h2 class="text-white"><a href="https://axcoraschool.vercel.app">CMS Sekolah</a> bekerja</h2>
    <p class="text-light">Pelajari bagaimana CMS aplikasi pembuatan website sekolah ini mudah untuk digunakan.</p>
    </div>
    </div>
    </div>
    
    <div class="row">
    <div class="col-6 col-xl-4 col-lg-4 col-md-6">
    <div class="services-caption text-center mb-30">
    <div class="service-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="text-white bi bi-grid-1x2" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M6 1H1v14h5V1zm9 0h-5v5h5V1zm0 9h-5v5h5v-5zM0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm1 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-5z"/>
          </svg>
    </div>
    <div class="service-cap">
    <h4 class="text-white">Kategori List</h4>
    <p class="text-white">Struktur dengan kategori yang rapi untuk pengelompokan  artikel.</p>
    </div>
    </div>
    </div>
    <div class="col-6 col-xl-4 col-lg-4 col-md-6">
    <div class="services-caption active text-center mb-30">
    <div class="service-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="text-white bi bi-layers-half" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M3.188 8L.264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l-4.578 2.441a.5.5 0 0 1-.47 0L3.188 8z"/>
            <path fill-rule="evenodd" d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4zM1.563 6L8 9.433 14.438 6 8 2.567 1.562 6z"/>
          </svg>
    </div>
    <div class="service-cap">
        <h4 class="text-white">Artikel Update</h4>
    <p class="text-white">Semakin mudah dan cepat dalam update konten artikel website sekolah.</p>
    </div>
    </div>
    </div>
    <div class="col-6 col-xl-4 col-lg-4 col-md-6">
    <div class="services-caption text-center mb-30">
    <div class="service-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="text-white bi bi-gem" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M3.1.7a.5.5 0 0 1 .4-.2h9a.5.5 0 0 1 .4.2l2.976 3.974c.149.185.156.45.01.644L8.4 15.3a.5.5 0 0 1-.8 0L.1 5.3a.5.5 0 0 1 0-.6l3-4zm11.386 3.785l-1.806-2.41-.776 2.413 2.582-.003zm-3.633.004l.961-2.989H4.186l.963 2.995 5.704-.006zM5.47 5.495l5.062-.005L8 13.366 5.47 5.495zm-1.371-.999l-.78-2.422-1.818 2.425 2.598-.003zM1.499 5.5l2.92-.003 2.193 6.82L1.5 5.5zm7.889 6.817l2.194-6.828 2.929-.003-5.123 6.831z"/>
          </svg>
    </div>
    <div class="service-cap">
    <h4 class="text-white">Modern Desain</h4>
    <p class="text-white">Era modern saat ini menggunakan modern landing page desain semakin informatif.</p>
    </div>
    </div>
    </div>
    <div class="col-6 col-xl-4 col-lg-4 col-md-6">
        <div class="services-caption active text-center mb-30">
        <div class="service-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="text-white bi bi-image-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094L15.002 9.5V13a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-1zm5-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
              </svg>
        </div>
        <div class="service-cap">
        <h4 class="text-white">Upload Media</h4>
        <p class="text-white">Upload Foto kegiatan semakin mudah dengan fitur upload media manager.</p>
        </div>
        </div>
        </div>
        <div class="col-6 col-xl-4 col-lg-4 col-md-6">
            <div class="services-caption active text-center mb-30">
            <div class="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="text-white bi bi-controller" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M11.119 2.693c.904.19 1.75.495 2.235.98.407.408.779 1.05 1.094 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.815-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773a11.307 11.307 0 0 1-.739-.809c-.126-.147-.25-.291-.368-.422-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.422-.243.283-.494.576-.739.81-.398.378-.877.705-1.513.772a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772.486-.485 1.331-.79 2.235-.98.932-.196 2.03-.292 3.119-.292 1.089 0 2.187.096 3.119.292zm-6.032.979c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.505C4.861 9.97 5.978 9.026 8 9.026s3.139.943 3.965 1.855c.164.182.307.35.44.505.214.25.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z"/>
                    <path d="M11.5 6.026a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-7-2.5h1v3h-1v-3z"/>
                    <path d="M3.5 6.526h3v1h-3v-1zM3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .258.966l-1.932.518a.5.5 0 0 1-.612-.354zm9.976 0a.5.5 0 0 0-.353-.613l-1.932-.518a.5.5 0 1 0-.259.966l1.932.518a.5.5 0 0 0 .612-.354z"/>
                  </svg>
            </div>
            <div class="service-cap">
            <h4 class="text-white">Setting Fitur</h4>
            <p class="text-white">Konfigurasi website app sekolah tersedia dalam informasi kontak.</p>
            </div>
            </div>
            </div>
            <div class="col-6 col-xl-4 col-lg-4 col-md-6">
                <div class="services-caption active text-center mb-30">
                <div class="service-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="text-white bi bi-lightning-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"/>
                      </svg>
                </div>
                <div class="service-cap">
                <h4 class="text-white">Fast Loading</h4>
                <p class="text-white">Kecepatan website sekolah menjadi prioritas utama.</p>
                </div>
                </div>
                </div>
                <div class="col-12 col-md-12 p-3 p-md-5">
                   
                    <div class="service-cap">
                   <img class="img-fluid rounded shadow" alt="Cms sekolah" src="assets/img/aplikasi pembuatan website sekolah gratis.jpg"/>
                    </div>
                    </div>
                   
    </div>
    </div>
    </div>
    
    <div id="skema" class="our-customer section-padd-top30">
        <div class="container">
        <div class="our-customer-wrapper">
        
        <div class="row d-flex justify-content-center">
        <div class="col-xl-8">
        <div class="section-tittle text-center">
        <h2 class=" text-white">Skema Dan tema<br> <a href="https://axcoraschool.vercel.app">CMS Sekolah</a></h2>
        </div>
        </div>
        </div>
        <div class="row text-white">
        
        <div class="col-6 col-md-6 p-3">
               <div class="what-cap">
        <h4 class="text-white"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
            <path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
          </svg> Home Page</h4>
        <p class="text-white">Halaman utama dengan landing page dan memberikan informasi mengenai sekolah dengan sub kategori.</p>
        </div>
        </div>
        <div class="col-6 col-md-6 p-3">
         <div class="what-cap">
        <h4 class="text-white"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"/>
            <circle cx="8" cy="4.5" r="1"/>
          </svg> Informasi</h4>
        <p class="text-white">Halaman informasi dengan pengelompokan kategori informasi seperti  PPDB , kurikulum , fasilitas , pengumuman , agenda dan berita sekolah.</p>
        </div>
        </div>
        <div class="col-6 col-md-6 p-3">
        <div class="what-cap">
            <h4 class="text-white"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trophy" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935zM3.504 1c.007.517.026 1.006.056 1.469.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.501.501 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667.03-.463.049-.952.056-1.469H3.504z"/>
              </svg> Profile</h4>
            <p class="text-white">Halaman profile dengan kategori informasi sekolah mengenai Profile mengenai sekolah Sejarah , Visi Misi , Kepala Sekolah , Staff Guru , dll.</p>
        </div>
        </div>
        <div class="col-6 col-md-6 p-3">
       <div class="what-cap">
        <h4 class="text-white"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
          </svg> Update</h4>
        <p class="text-white">Halaman informasi Artikel dan post bebas untuk update informasi pada website sekolahan.</p>
           </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
    
    <div class="applic-apps section-padding2">
    <div class="container-fluid">
    <div class="row">
    
    <div class="col-12 col-md-4 p-3 p-md-5">
    <div class="border border-light p-3 p-md-5">
    <h3 class="text-white">Mobile</h3>
    <p class="text-white">Mudah untuk akses via pc desktop laptop dan smartphone anda. </p>
    </div>
    </div>
    
    <div class="col-12 col-md-8 p-3 p-md-5">
    <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
    <img class="img-fluid" src="assets/img/aplikasi pembuatan website sekolah gratis dari axcora technology axcora school web app login.png" alt="aplikasi pembuatan website khusus sekolah"/>
    </div>
        <div class="carousel-item">
    <img class="img-fluid" src="assets/img/aplikasi pembuatan website sekolah gratis dari axcora technology axcora school web app.png" alt="cms sekolah axcora school"/>
    </div>
        </div>
      <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </a>
    </div>
    </div>
    
    
  
    <div id="pricing" class="container">
    
    <div class="row d-flex justify-content-center">
    <div class="col-lg-6 col-md-8">
    <div class="section-tittle section-tittle2 text-center">
    <h2 class="text-white">Pilih Paket Website Sekolah.</h2>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="pricing-card-area">
    <div class="container">
    <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6 p-3 p-md-5">
            <div class="single-card text-center mb-30 bg-white rounded p-3 p-md-3 text-secondary">
            <div class="card-top">
            <span>Sourcecode</span>
            <h4>FREE <span>Gratis</span></h4>
            </div>
            <div class="card-bottom">
            <ul>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Axcora School CMS</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Full Features</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Free to Modify Code</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Domain .sch.id</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Hosting Include</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Custom Design</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Setting Installasi</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Layanan support</li>
            </ul>
            <br/>
            <a href="https://sourceforge.net/projects/axcoraschool/files/latest/download" target="blank" class="btn card-btn1">Get Started</a>
            </div>
            </div>
            </div>
        <div class="col-xl-4 col-lg-4 col-md-6 p-3 p-md-5">
    <div class="single-card text-center mb-30 bg-white rounded shadow p-3 p-md-3">
    <div class="card-top bg-primary text-white rounded">
        <span>Standard</span>
        <h4 class="text-white"><strong>Rp.1.561.200</strong></h4>
        <span>per tahun</span>
    </div>
    <div class="card-bottom">   <br/>
    <ul>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Axcora School CMS</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Full Features</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Free to Modify Code</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Domain .sch.id</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Hosting Include</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Custom Design</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Setting Installasi</li>
    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
        </svg> Layanan support</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> 500MB Web Space</li>
    </ul>
    <br/>
    <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3AStandardAxcoraschoolcms%0APrice%20%3ARp.1.561.200/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Get Started</a>
    </div>
    </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 p-3 p-md-5">
        <div class="single-card text-center mb-30 bg-white rounded shadow p-3 p-md-3">
        <div class="card-top bg-danger text-white rounded">
            <span>Premium</span>
            <h4 class="text-white"><strong>Rp.3.634.700</strong></h4>
            <span>per tahun</span>
        </div>
        <div class="card-bottom">   <br/>
        <ul>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Axcora School CMS</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Full Features</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Free to Modify Code</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Domain .sch.id</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Hosting Include</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Custom Design</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Setting Installasi</li>
        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
            </svg> Layanan support</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Aplikasi Absensi</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Aplikasi E-learn free</li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> 1.5GB web space</li>
        </ul>
        <br/>
        <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3APremiumaxcoraschoolcms%0APrice%20%3ARp.1.561.200/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Get Started</a>
        </div>
        </div>
        </div>
    </div>
    </div>
    </div>
    
    
   
    <div class="row">
     <div class="col-12 col-lg-12 text-center p-3">
    <div class="app-img">
    <img class="img-fluid" src="assets/img/aplikasi pembuatan website sekolah gratis dari axcora technology axcora school web app2.png" alt="cms sekolah aplikasi pembuatan website sekolah gratis"/>
    </div>
</div>
    
    
    <div class="say-something-aera pt-90 pb-90 fix">
    <div class="container">
    <div class="row justify-content-between align-items-center">
    <div class="col-xl-12 col-lg-12">
    <div class="say-something-cap">
    <h2 class="text-white">Saat nya menggunakan axcora school cms untuk pembuatan website sekolah.</h2>
    </div>
    </div>
     </div>
    </div>
    
   
    </div>
    
 
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/axcoraschool" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
